const state = {
  mpvueInfo: '基于 Vue.js 的小程序开发框架，从底层支持 Vue.js 语法和构建工具体系。',
  title: '软盟',
  profile: {
    attribute: {},
    company: {}
  },
  taxonomyList: [
    {
      tabId: 0,
      icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_img_wechat.png',
      name: '微信',
      navName: '微信营销',
      tabType: 'woa',
      mediaAvatarShow: true,
      mediaBargeShow: true,
      mediaPlatformShow: false,
      analysisTypes: ['category', 'fansNum', 'avgReadNum'],
      analysisDetailTypes: ['avgReadNumTop', 'avgLikeNumTop', 'avgReadNumUntop', 'avgLikeNumUntop', 'maxReadNum', 'maxLikeNum'],
      iconClass: 'icon-weixinicon',
      iconClassColor: '#63ca71',
      sortName: ['综合排序', '头条价格', '非头条价格', '粉丝量'],
      sortField: ['', 'price', 'price_second', 'fan_num'],
      priceType: ['top', 'non_top'],
      priceTypeName: ['头条价', '非头条价']
    },
    {
      tabId: 1,
      icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_img_redbook.png',
      name: '小红书',
      navName: '小红书',
      tabType: 'xhs',
      mediaAvatarShow: true,
      mediaBargeShow: false,
      mediaPlatformShow: false,
      analysisTypes: ['category', 'fansNum', 'avgLikeNum'],
      iconClass: 'icon-xiaohongshu',
      iconClassColor: '#ff0000',
      sortName: ['综合排序', '图文价格', '视频价格', '粉丝量'],
      sortField: ['', 'price_second', 'price', 'fans_num'],
      priceType: ['video', 'imagetext'],
      priceTypeName: ['视频', '图文']
    },
    {
      tabId: 2,
      icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_img_weibo.png',
      name: '微博',
      navName: '微博营销',
      tabType: 'weibo',
      mediaAvatarShow: true,
      mediaBargeShow: false,
      mediaPlatformShow: false,
      analysisTypes: ['category', 'fansNum', 'avgLikeNum'],
      iconClass: 'icon-weibo1',
      iconClassColor: '#b6362f',
      sortName: ['综合排序', '价格', '粉丝量', '转发量', '点赞量'],
      sortField: ['', 'price', 'fan_num', 'avg_retweet_num', 'avg_like_num'],
      priceType: ['tweet', 'retweet'],
      priceTypeName: ['直发价', '转发价']
    },
    {
      tabId: 3,
      icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_img_video.png',
      name: '短视频',
      navName: '视频营销',
      tabType: 'video',
      mediaAvatarShow: true,
      mediaBargeShow: false,
      mediaPlatformShow: true,
      analysisTypes: ['category', 'fansNum', 'avgPlayNum'],
      iconClass: 'icon-duanshipin',
      iconClassColor: '#ae7af5',
      sortName: ['综合排序', '价格', '播放量', '粉丝量'],
      sortField: ['', 'price', 'avg_play_num', 'fan_num'],
      priceType: ['original_publish', 'publish'],
      priceTypeName: ['原创发布', '发布']
    },
    {
      tabId: 4,
      icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_img_live.png',
      name: '网红',
      navName: '网红直播',
      tabType: 'live',
      mediaAvatarShow: true,
      mediaBargeShow: false,
      mediaPlatformShow: true,
      analysisTypes: ['category', 'fansNum', 'avgAudienceNum'],
      iconClass: 'icon-zhibo',
      iconClassColor: '#ed8532',
      sortName: ['综合排序', '价格', '粉丝量'],
      sortField: ['', 'price', 'fan_num'],
      priceType: ['online', 'offline'],
      priceTypeName: ['线上直播', '线下转发']
    }
    // {
    //   tabId: 5,
    //   icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_img_news.png',
    //   name: '软文',
    //   navName: '软文推广',
    //   tabType: 'news',
    //   mediaAvatarShow: false,
    //   mediaBargeShow: false,
    //   analysisTypes: ['category', 'publishRate', 'mbaiduRank'],
    //   iconClass: 'icon-ruanwen-huoyan',
    //   iconClassColor: '#e93f33',
    //   sortName: ['综合排序', '价格', 'PC权重', 'WAP权重', '出稿率'],
    //   sortField: ['', 'price', 'pc_baidu_rank', 'm_baidu_rank', 'publish_rate'],
    //   priceType: [''],
    //   priceTypeName: ['参考价']
    // }
  ]
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js